import { lazy } from 'react';

export const ChallengeRewardCreateForm = lazy(
  () => import('./ChallengeRewardCreateForm'),
);
